import { render, staticRenderFns } from "./AddPositionHelp.vue?vue&type=template&id=46fd9692"
import script from "./AddPositionHelp.vue?vue&type=script&lang=js"
export * from "./AddPositionHelp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports